// src/plugins/alertPlugin.js
import { h, createApp, reactive } from 'vue';
import { createBootstrap } from 'bootstrap-vue-next';
import AlertModal from '@/components/AlertModal.vue';

const alertPlugin = {
  install(app) {
    function createModal(props, onResolve) {
      const state = reactive({
        visible: true,
        ...props,
      });

      const container = document.createElement('div');
      document.body.appendChild(container);

      let modalApp = null;
      let resolvido = false;

      function resolver(valor) {
        if (resolvido) return;

        resolvido = true;
        cleanup();
        onResolve(valor);
      }

      function cleanup() {
        if (modalApp) {
          modalApp.unmount();
          modalApp = null;
        }

        if (container.parentNode) {
          container.parentNode.removeChild(container);
        }
      }

      modalApp = createApp({
        render() {
          return h(AlertModal, {
            ...state,

            onClose: () => {
              if (props.type === 'alert') {
                resolver();
              }
            },

            onConfirm: () => {
              if (props.type === 'confirm') {
                resolver(true);
              }
            },

            onCancel: () => {
              if (props.type === 'confirm') {
                resolver(false);
              }
            },
          });
        },
      });

      /**
       * Herda o contexto da aplicação principal:
       * globalProperties, store, router, provides, components, directives etc.
       */
      modalApp._context = app._context;

      /**
       * Registra o BootstrapVueNext corretamente nesta mini-aplicação.
       * Necessário para o BModal encontrar o modalManager.
       */
      modalApp.use(createBootstrap());

      /**
       * Mantém o warnHandler da aplicação principal, se existir.
       */
      if (typeof app.config.warnHandler === 'function') {
        modalApp.config.warnHandler = app.config.warnHandler;
      }

      modalApp.mount(container);
    }

    function $alert(message, title = 'Aviso') {
      return new Promise((resolve) => {
        createModal(
          {
            message,
            title,
            type: 'alert',
          },
          resolve
        );
      });
    }

    function $confirm(message, title = 'Confirmação') {
      return new Promise((resolve) => {
        createModal(
          {
            message,
            title,
            type: 'confirm',
          },
          resolve
        );
      });
    }

    app.config.globalProperties.$alert = $alert;
    app.config.globalProperties.$confirm = $confirm;
  },
};

export default alertPlugin;